module.exports = __webpack_public_path__ + "static/media/Rolloslomito.3d5dbfdb.jpg";